import { cn } from './ui-x';

const initials = (name?: string | null) =>
  (name ?? '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase() || '—';

/*
 * The placeholder the API hands back when nobody has uploaded a photo. It is
 * a real URL, so `src ? <img>` renders it happily -- which is how a cartoon
 * ended up standing in for people who simply have no picture. Matched on the
 * cloudinary public id rather than the whole URL so a size or format
 * transform in the path does not slip past it.
 */
const DEFAULT_PHOTO_ID = 'fyd319ojzgxvzqlhgv9x';

/* A type predicate, so the <img> below still narrows src to a string the
   way the old `src ? ` check did. */
const hasPhoto = (src?: string | null): src is string =>
  !!src && !src.includes(DEFAULT_PHOTO_ID);

/**
 * Logo with an initials fallback. Table cells previously rendered
 * `src={x ?? ""}`, which paints a broken-image glyph when there is no logo.
 */
const EntityAvatar = ({
  src,
  name,
  className = 'h-9 w-9',
}: {
  src?: string | null;
  name?: string | null;
  className?: string;
}) =>
  hasPhoto(src) ? (
    <img
      src={src}
      alt=''
      aria-hidden='true'
      className={cn('shrink-0 rounded-full border object-cover', className)}
    />
  ) : (
    <span
      aria-hidden='true'
      className={cn(
        'grid shrink-0 place-items-center rounded-full bg-brand-navy-100 text-[11px] font-bold text-brand-navy',
        className
      )}
    >
      {initials(name)}
    </span>
  );

export default EntityAvatar;
